module.exports = __webpack_public_path__ + "img/project5_1.jpg.eebb09e2.webp";